export enum SecurityComponents {
    SideBarMenuItems = 'SideBarMenuItemsConfiguration',
    AppRutas = 'AppRutas',
    AdminPanel = 'AdminPanel'
}
